import GameSignals from '@/signals/GameSignals'
import { GameStatesEnum } from '@/states/GameStatesEnum'
import { RoundRestoreUtil } from '@/utils/RoundRestoreUtil'
import { BaseState } from '@stateMachine/BaseState'

export class StartRoundState extends BaseState {
    public begin() {
        RoundRestoreUtil.startRound()

        this._model.resetRoundState()
        this._model.winCounter.startRound()
        GameSignals.roundStart.emit(false)

        this.end()
    }

    public end = () => {
        this._stateMachine.setState(GameStatesEnum.START_SPIN_STATE)
    }

    public cleanUp() {
        // empty
    }
}
